import { __rest as e } from "tslib";
import * as i from "react";
import t from "classnames";
import { Text as s } from "../Text/Text.js";
import { ComponentClassNames as r } from "../shared/constants.js";
const a = "qa-field-description",
  d = a => {
    var {
        descriptiveText: d,
        labelHidden: l
      } = a,
      o = e(a, ["descriptiveText", "labelHidden"]);
    return d ? i.createElement(s, Object.assign({
      "data-testid": "qa-field-description",
      className: t(r.FieldDescription, {
        [r.VisuallyHidden]: l
      })
    }, o), d) : null;
  };
d.displayName = "FieldDescription";
export { d as FieldDescription, a as QA_FIELD_DESCRIPTION };